'use client';
import { SvgIconProps } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as ControllerIcon } from '../../../static/product_image/filter_controller.svg';

const FilterControllerIcon: React.FC<SvgIconProps> = ({ sx, ...rest }) => (
    <SvgIcon {...rest} component={ControllerIcon} inheritViewBox sx={{ ...sx }} />
);

export default FilterControllerIcon;
